<template>
  <el-container>
    <el-header class="header">
      <HeaderComponent></HeaderComponent>
    </el-header>
    <el-container>
      <SideBarComponent></SideBarComponent>
      <el-main class="main ai_main">
        <SubTitleComponent v-if="global.type == 'client'" :title="title"></SubTitleComponent>
        <div class="box">
          <!-- 选择客户 -->
          <div class="tool">
            <h4>选择客户</h4>
            <div class="search">
              <el-select
                v-model="customerValue"
                placeholder="请选择客户"
                @change="customerChange"
                :loading="customerLoading"
                filterable>
                <el-option
                  v-for="item in customerData"
                  :key="item.client_id"
                  :label="item.number + ' ' + item.client_name"
                  :value="item.client_id">
                </el-option>
              </el-select>
            </div>
          </div>

          <!-- 页面标题 -->
          <div class="part">
            <div class="page_header">
              <i class="el-icon-box header_icon"></i>
              <h3>平面转 3D 效果图</h3>
            </div>
          </div>

          <!-- 上传彩平图 -->
          <div class="part">
            <div class="upload_header">
              <h5>选择平面图（也可裁剪后上传需要生成的区域，会更准确哦）</h5>
              <el-button type="success" size="small" plain @click="openLibrary">
                <i class="el-icon-picture-outline"></i> 从生成库选择
              </el-button>
            </div>
            <div class="upload_area">
              <el-upload
                v-if="!uploadedColorPlan"
                class="upload_dragger"
                drag
                action=""
                :auto-upload="false"
                :show-file-list="false"
                :on-change="handleColorPlanUpload"
                accept="image/*">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">支持 JPG、PNG 格式图片</div>
              </el-upload>
              <div v-else class="preview_area">
                <img :src="uploadedColorPlan" alt="预览图">
                <el-button type="danger" size="small" class="clear_btn" @click="clearColorPlan">
                  <i class="el-icon-delete"></i> 清除
                </el-button>
              </div>
            </div>
            <div v-if="selectedPlanName" class="selected_plan_info">
              <span class="label">已选择：</span>{{ selectedPlanName }}
            </div>
          </div>

          <!-- 自动识别区域 -->
          <div class="part" v-if="uploadedColorPlan">
            <div class="detected_areas_card">
              <div class="card_header">
                <i class="el-icon-view"></i>
                <span>{{ isAnalyzingAreas ? '正在识别功能区域...' : '已自动识别功能区域' }}</span>
                <el-button
                  v-if="!isAnalyzingAreas"
                  type="text"
                  size="mini"
                  @click="analyzeFloorplanAreas(uploadedColorPlanUrl)"
                  style="margin-left: 10px;">
                  重新识别
                </el-button>
              </div>
              <div class="area_tags" v-if="!isAnalyzingAreas && detectedAreas.length > 0">
                <el-tag
                  v-for="area in detectedAreas"
                  :key="area.id"
                  type="info"
                  effect="plain">
                  {{ area.name }}
                </el-tag>
              </div>
              <div v-else-if="isAnalyzingAreas" class="area_loading">
                <i class="el-icon-loading"></i>
                <span>AI 正在分析平面图...</span>
              </div>
              <div v-else class="area_empty">
                <span>未识别到功能区域</span>
              </div>
            </div>
          </div>

          <!-- 提示词输入 -->
          <div class="part" v-if="uploadedColorPlan">
            <h5>提示词（可选）</h5>
            <div class="prompt_input_area">
              <el-input
                type="textarea"
                :rows="4"
                placeholder="输入提示词来定制3D效果图的风格，例如：现代简约风格、北欧风格、中式风格等。留空则使用默认风格。"
                v-model="stylePrompt"
                maxlength="500"
                show-word-limit
                resize="none">
              </el-input>
              <div class="prompt_tips">
                <i class="el-icon-info"></i>
                <span>提示：详细的风格描述可以生成更符合预期的效果图</span>
              </div>
            </div>
          </div>

          <!-- 生成方式 -->
          <div class="part" v-if="uploadedColorPlan">
            <h5>生成方式</h5>

            <!-- 生成3D平面设计图选项 -->
            <div
              :class="['mode_item', { 'selected': generate3DFloorPlan }]"
              @click="generate3DFloorPlan = !generate3DFloorPlan">
              <el-checkbox v-model="generate3DFloorPlan"></el-checkbox>
              <div class="mode_info">
                <span class="mode_name">生成3D平面设计图</span>
                <p class="mode_desc">除了3D效果图，同时生成3D俯视平面设计图</p>
              </div>
            </div>

            <!-- 生成模式选择 -->
            <el-radio-group v-model="generateMode" class="mode_radio_group">
              <div
                :class="['mode_item', { 'selected': generateMode === 'all' }]"
                @click="generateMode = 'all'">
                <el-radio label="all">{{''}}</el-radio>
                <div class="mode_info">
                  <span class="mode_name">全部生成</span>
                  <p class="mode_desc">生成所有识别区域的 3D 效果图（1.5-1.6m 眼位平视视角）</p>
                </div>
              </div>
              <div
                :class="['mode_item', { 'selected': generateMode === 'select' }]"
                @click="generateMode = 'select'">
                <el-radio label="select">{{''}}</el-radio>
                <div class="mode_info">
                  <span class="mode_name">选择区域生成</span>
                  <p class="mode_desc">自定义选择需要生成的区域</p>
                </div>
              </div>
            </el-radio-group>
          </div>

          <!-- 区域选择 -->
          <div class="part" v-if="uploadedColorPlan && generateMode === 'select'">
            <h5>选择生成区域（可多选）</h5>
            <div class="area_select_grid">
              <div
                v-for="area in detectedAreas"
                :key="area.id"
                :class="['area_item', { 'selected': selectedAreas.includes(area.id) }]"
                @click="toggleArea(area.id)">
                <el-checkbox :value="selectedAreas.includes(area.id)"></el-checkbox>
                <span class="area_name">{{ area.name }}</span>
              </div>
            </div>
          </div>

          <!-- 渲染信息卡片 -->
          <div class="info_card">
            <div class="info_row">
              <span class="info_label">视角设置</span>
              <span class="info_value">1.5-1.6m 眼位平视</span>
            </div>
            <div class="info_row">
              <span class="info_label">渲染内容</span>
              <span class="info_value">墙面 / 地面 / 天花板</span>
            </div>
          </div>

          <!-- 生成按钮 -->
          <div class="btn_save">
            <el-button
              type="success"
              :loading="isGenerating"
              @click="handleGenerate"
              :disabled="!uploadedColorPlan || !customerValue || (generateMode === 'select' && selectedAreas.length === 0)"
              style="width:100%;">
              {{ isGenerating ? '生成中...' : '立即生成 3D 效果图' }}
            </el-button>
            <div class="prompt">（本月剩余使用额度 {{ global.money }}元）</div>
          </div>

          <!-- 生成结果 -->
          <div class="part" v-if="generatedImages.length > 0">
            <h5>生成结果</h5>
            <!-- 3D平面设计图 -->
            <div class="result_floorplan" v-if="floorplanImage">
              <div :class="['result_item_3d', 'floorplan']">
                <!-- 生成中状态 -->
                <div v-if="floorplanImage.status === 'pending'" class="result_loading">
                  <i class="el-icon-loading"></i>
                  <span>{{ floorplanImage.area }} 生成中...</span>
                </div>
                <!-- 生成失败状态 -->
                <div v-else-if="floorplanImage.status === 'error'" class="result_error">
                  <i class="el-icon-warning"></i>
                  <span>{{ floorplanImage.area }} 生成失败</span>
                </div>
                <!-- 生成完成状态 -->
                <template v-else>
                  <img :src="floorplanImage.url" alt="" class="result_image" @click="previewImage(floorplanImage.url)">
                  <div class="result_info">
                    <p class="result_title">{{ floorplanImage.area }} - 3D 效果图</p>
                    <p class="result_desc">90度正上方俯视视角</p>
                    <div class="result_actions">
                      <el-button size="mini" type="success" plain @click="handleCollect(floorplanImage)">收藏</el-button>
                      <el-button size="mini" type="success" plain @click="handleDownload(floorplanImage)">下载</el-button>
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <!-- 区域图 -->
            <div class="result_list" v-if="areaImages.length > 0">
              <div
                v-for="(img, index) in areaImages"
                :key="'result'+index"
                class="result_item_3d">
                <!-- 生成中状态 -->
                <div v-if="img.status === 'pending'" class="result_loading">
                  <i class="el-icon-loading"></i>
                  <span>{{ img.area }} 生成中...</span>
                </div>
                <!-- 生成失败状态 -->
                <div v-else-if="img.status === 'error'" class="result_error">
                  <i class="el-icon-warning"></i>
                  <span>{{ img.area }} 生成失败</span>
                </div>
                <!-- 生成完成状态 -->
                <template v-else>
                  <img :src="img.url" alt="" class="result_image" @click="previewImage(img.url)">
                  <div class="result_info">
                    <p class="result_title">{{ img.area }} - 3D 效果图</p>
                    <p class="result_desc">1.5m 眼位平视视角</p>
                    <div class="result_actions">
                      <el-button size="mini" type="success" plain @click="handleCollect(img)">收藏</el-button>
                      <el-button size="mini" type="success" plain @click="handleDownload(img)">下载</el-button>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>

          <!-- 优质示例展示 -->
          <div class="example_section" v-if="exampleList.length > 0">
            <div class="example_header">
              <h5>优质案例</h5>
            </div>
            <div class="example_grid">
              <div
                v-for="item in exampleList"
                :key="'example'+item.id"
                class="example_item"
                @click="previewExample(item)">
                <img :src="item.photo_url + '?x-oss-process=image/resize,w_300'" alt="">
              </div>
            </div>
          </div>
        </div>

        <!-- 彩平图库弹窗 -->
        <el-dialog
          title="选择彩平图"
          :visible.sync="libraryOpen"
          width="70%"
          :close-on-click-modal="false">
          <p class="dialog_hint">从已生成的彩平图库中选择一张满意的彩平图继续操作</p>

          <!-- 加载中状态 -->
          <div v-if="libraryLoading" class="library_loading">
            <i class="el-icon-loading"></i>
            <span>加载中...</span>
          </div>

          <!-- 空数据状态 -->
          <div v-else-if="colorPlanLibrary.length === 0" class="library_empty">
            <i class="el-icon-picture-outline"></i>
            <p>暂无彩平图数据</p>
            <p class="hint">请先在"平面图转彩平"页面生成彩平图</p>
          </div>

          <!-- 图库列表 -->
          <div v-else class="library_grid">
            <div
              v-for="plan in colorPlanLibrary"
              :key="plan.id"
              class="library_item"
              @click="handleLibrarySelect(plan)">
              <img :src="plan.thumbnail" alt="">
              <div class="library_item_info">
                <p class="name">{{ plan.name }}</p>
              </div>
            </div>
          </div>
        </el-dialog>

        <!-- 图片预览弹窗 -->
        <el-dialog
          :visible.sync="previewVisible"
          width="auto"
          :close-on-click-modal="true"
          custom-class="image-preview-dialog"
          :modal-append-to-body="true"
          :append-to-body="true">
          <img :src="previewImageUrl" class="preview-dialog-image">
        </el-dialog>

        <!-- 示例详情弹窗 -->
        <el-dialog
          title="示例详情"
          :visible.sync="exampleDetailVisible"
          width="80%"
          top="5vh"
          :close-on-click-modal="true"
          custom-class="example-detail-dialog">
          <div class="example_detail" v-if="currentExample">
            <!-- 有原始图片时，横排显示两张图 -->
            <div v-if="currentExample.original_photo_url" class="detail_images_row">
              <div class="image_item">
                <p class="image_label">原始图片</p>
                <img :src="currentExample.original_photo_url" alt="原始图">
              </div>
              <div class="image_item">
                <p class="image_label">生成结果</p>
                <img :src="currentExample.photo_url" alt="生成结果">
              </div>
            </div>
            <!-- 只有一张图时，正常显示 -->
            <div v-else class="detail_single_layout">
              <div class="detail_left">
                <img :src="currentExample.photo_url" alt="">
              </div>
              <div class="detail_right">
                <div class="detail_item">
                  <label>提示词/描述：</label>
                  <p>{{ currentExample.description }}</p>
                </div>
                <div class="detail_item">
                  <label>使用模型：</label>
                  <p>{{ currentExample.model_name }}</p>
                </div>
                <div class="detail_item" v-if="currentExample.style_type">
                  <label>风格类型：</label>
                  <p>{{ currentExample.style_type }}</p>
                </div>
                <div class="detail_item" v-if="currentExample.space_type">
                  <label>空间类型：</label>
                  <p>{{ currentExample.space_type }}</p>
                </div>
                <div class="detail_actions">
                  <el-button type="success" @click="useThisExample">使用此提示词</el-button>
                </div>
              </div>
            </div>
            <!-- 有原始图片时，信息显示在下方 -->
            <div v-if="currentExample.original_photo_url" class="detail_info_bottom">
              <div class="detail_item">
                <label>提示词/描述：</label>
                <p>{{ currentExample.description }}</p>
              </div>
              <div class="detail_item">
                <label>使用模型：</label>
                <p>{{ currentExample.model_name }}</p>
              </div>
              <div class="detail_item" v-if="currentExample.style_type">
                <label>风格类型：</label>
                <p>{{ currentExample.style_type }}</p>
              </div>
              <div class="detail_item" v-if="currentExample.space_type">
                <label>空间类型：</label>
                <p>{{ currentExample.space_type }}</p>
              </div>
              <div class="detail_actions">
                <el-button type="success" @click="useThisExample">使用此提示词</el-button>
              </div>
            </div>
          </div>
        </el-dialog>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent'
import SideBarComponent from '@/components/SideBarComponent'
import SubTitleComponent from '@/components/SubTitleComponent'
import { apiDownload } from '@/utils/download'

export default {
  name: 'ColorTo3D',
  components: {
    HeaderComponent,
    SideBarComponent,
    SubTitleComponent
  },
  data() {
    return {
      title: '平面转3D效果图',
      customerData: [],
      customerValue: '',
      customerLoading: false,
      uploadedColorPlan: null,
      uploadedColorPlanUrl: '', // OSS上传后的URL
      selectedPlanName: '',
      stylePrompt: '', // 风格提示词
      generate3DFloorPlan: true,
      generateMode: 'all',
      selectedAreas: [],
      isGenerating: false,
      generatedImages: [],
      libraryOpen: false,
      detectedAreas: [],
      isAnalyzingAreas: false,
      colorPlanLibrary: [],
      libraryLoading: false,
      previewVisible: false,
      previewImageUrl: '',
      areasToGenerate: [], // 待生成的区域列表
      pendingTasks: 0,
      // 示例展示相关
      exampleList: [],
      exampleDetailVisible: false,
      currentExample: null
    }
  },
  computed: {
    floorplanImage() {
      return this.generatedImages.find(img => img.isFloorplan)
    },
    areaImages() {
      return this.generatedImages.filter(img => !img.isFloorplan)
    }
  },
  created() {
    this.getCustomerList()
    this.getExampleList()
  },
  methods: {
    // 获取客户列表
    getCustomerList() {
      this.customerLoading = true
      let _url = "/api/?mod=client&action=all"
      this.axios.post(_url).then(json => {
        let _data = json.data.data
        if (json.data.errcode === 0) {
          this.customerData = _data.result

          // 自动选择客户
          if (this.customerData.length > 0) {
            if (this.global.type === 'client' && this.global.clientId) {
              this.customerValue = parseInt(this.global.clientId)
            } else if (this.global.clientName) {
              const rememberedClient = this.customerData.find(c => c.client_name === this.global.clientName)
              if (rememberedClient) {
                this.customerValue = rememberedClient.client_id
              } else {
                this.customerValue = this.customerData[0].client_id
              }
            } else {
              this.customerValue = this.customerData[0].client_id
            }

            // 更新全局状态
            const selectedCustomer = this.customerData.find(c => c.client_id === this.customerValue)
            if (selectedCustomer) {
              this.global.clientId = selectedCustomer.client_id
              this.global.clientName = selectedCustomer.client_name
            }
          }
        } else {
          this.$message.error(json.data.error || '获取客户列表失败')
        }
      }).catch(err => {
        console.error('获取客户列表错误:', err)
        this.$message.error('网络错误，无法获取客户列表')
      }).finally(() => {
        this.customerLoading = false
      })
    },
    // 客户选择变化
    customerChange(val) {
      const selectedCustomer = this.customerData.find(c => c.client_id === val)
      if (selectedCustomer) {
        this.global.clientId = selectedCustomer.client_id
        this.global.clientName = selectedCustomer.client_name
      }
    },
    // 处理彩平图上传
    handleColorPlanUpload(file) {
      const isImage = file.raw.type.startsWith('image/')
      if (!isImage) {
        this.$message.error('只能上传图片文件')
        return false
      }
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('图片大小不能超过 10MB')
        return false
      }
      // 显示预览
      const reader = new FileReader()
      reader.onload = (e) => {
        this.uploadedColorPlan = e.target.result
        this.selectedPlanName = ''
        this.selectedAreas = []
        this.generateMode = 'all'
      }
      reader.readAsDataURL(file.raw)
      // OSS直传
      this.uploadToOSS(file.raw)
    },
    // OSS直传
    uploadToOSS(file) {
      var self = this
      var loading = this.$loading({
        lock: true,
        text: '正在上传图片...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      // 1. 获取OSS签名
      var _url = "/api/?mod=oss&action=signature"
      self.axios.post(_url).then(function(json) {
        if (json.data.errcode !== 0) {
          self.$message.error(json.data.error || '获取签名失败')
          loading.close()
          return
        }

        var ossData = json.data.data
        var timestamp = Date.now()
        var random = Math.floor(Math.random() * 10000)
        var fileExt = file.name.split('.').pop()
        var fileName = timestamp + '' + random + '.' + fileExt
        var key = ossData.dir + fileName

        // 2. 构造FormData上传到OSS
        var formData = new FormData()
        formData.append('key', key)
        formData.append('policy', ossData.policy)
        formData.append('OSSAccessKeyId', ossData.accessid)
        formData.append('signature', ossData.signature)
        formData.append('success_action_status', '200')
        formData.append('file', file)

        // 3. 直接上传到OSS
        self.axios.post(ossData.host, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          transformRequest: [function(data, headers) {
            delete headers.Authorization
            return data
          }],
          // OSS返回空字符串，明确告诉axios这是成功的响应
          validateStatus: function(status) {
            return status === 200
          }
        }).then(function() {
          // 上传成功，保存URL
          self.uploadedColorPlanUrl = ossData.host + '/' + key
          self.$message.success('图片上传成功')
          loading.close()
          // 调用功能区域识别
          self.analyzeFloorplanAreas(self.uploadedColorPlanUrl)
        }).catch(function() {
          self.$message.error('图片上传失败')
          self.uploadedColorPlan = null
          loading.close()
        })
      }).catch(function() {
        self.$message.error('网络错误')
        loading.close()
      })
    },
    // 清除彩平图
    clearColorPlan() {
      this.uploadedColorPlan = null
      this.uploadedColorPlanUrl = ''
      this.selectedPlanName = ''
      this.selectedAreas = []
      this.generateMode = 'all'
      this.detectedAreas = []
    },
    // 识别平面图功能区域
    analyzeFloorplanAreas(photoUrl) {
      this.isAnalyzingAreas = true
      this.detectedAreas = []
      let _url = "/api/?mod=translate&action=floorplan-areas"
      this.axios.post(_url, { photo_url: photoUrl }).then(json => {
        if (json.data.errcode === 0 && json.data.data.areas) {
          this.detectedAreas = json.data.data.areas
        } else {
          this.$message.warning(json.data.error || '功能区域识别失败')
        }
      }).catch(() => {
        this.$message.error('网络错误，功能区域识别失败')
      }).finally(() => {
        this.isAnalyzingAreas = false
      })
    },
    // 打开图库弹窗
    openLibrary() {
      this.libraryOpen = true
      this.getColorPlanLibrary()
    },
    // 获取彩平图库
    getColorPlanLibrary() {
      if (!this.customerValue) {
        this.$message.warning('请先选择客户')
        return
      }
      this.libraryLoading = true
      let _url = "/api/?mod=effect&action=result_list"
      this.axios.post(_url, {
        client_id: this.customerValue,
        type: 4,
        page: 1,
        pagesize: 20
      }).then(json => {
        if (json.data.errcode === 0) {
          this.colorPlanLibrary = json.data.data.result.map(item => {
            return {
              id: item.effect_result_id,
              name: item.space_type || '彩平图',
              url: item.photo_url,
              thumbnail: item.photo_url
            }
          })
        } else {
          this.$message.error(json.data.error || '获取图库失败')
        }
      }).catch(() => {
        this.$message.error('网络错误，无法获取图库')
      }).finally(() => {
        this.libraryLoading = false
      })
    },
    // 从库中选择
    handleLibrarySelect(plan) {
      this.uploadedColorPlan = plan.url
      this.uploadedColorPlanUrl = plan.url  // 设置OSS URL用于API调用
      this.selectedPlanName = plan.name
      this.libraryOpen = false
      this.selectedAreas = []
      this.generateMode = 'all'
      // 调用功能区域识别
      this.analyzeFloorplanAreas(plan.url)
    },
    // 切换区域选择
    toggleArea(areaId) {
      const index = this.selectedAreas.indexOf(areaId)
      if (index > -1) {
        this.selectedAreas.splice(index, 1)
      } else {
        this.selectedAreas.push(areaId)
      }
    },
    // 生成3D效果图
    handleGenerate() {
      if (!this.uploadedColorPlan) {
        this.$message.warning('请先上传彩色平面图')
        return
      }
      if (!this.customerValue) {
        this.$message.warning('请选择客户')
        return
      }
      if (this.detectedAreas.length === 0) {
        this.$message.warning('请等待功能区域识别完成')
        return
      }
      if (this.generateMode === 'select' && this.selectedAreas.length === 0) {
        this.$message.warning('请选择要生成的区域')
        return
      }

      // 获取要生成的区域
      const areasToGenerate = this.generateMode === 'all'
        ? this.detectedAreas
        : this.detectedAreas.filter(a => this.selectedAreas.includes(a.id))

      this.isGenerating = true
      this.generatedImages = []
      this.pendingTasks = 0

      // 保存要生成的区域列表，供后续使用
      this.areasToGenerate = areasToGenerate

      // 构建基础提示词
      let baseStylePrompt = this.stylePrompt.trim()
        ? this.stylePrompt.trim()
        : '现代极简风格，高级感氛围'

      // 先生成3D平面设计图，完成后再生成局部图
      const floorplanPrompt = `将平面图转化为一张90度正上方俯视效果图。写实3D风格，展现墙体和家具的立体厚度。${baseStylePrompt}。柔和顶部漫射光，软阴影。图中元素保持不变。`
      this.submitGenerateTask(floorplanPrompt, '3D平面设计图', this.uploadedColorPlanUrl, true, baseStylePrompt)
    },
    // 提交生成任务
    submitGenerateTask(prompt, areaName, referenceImageUrl, isFloorplan = false, baseStylePrompt = '') {
      let _url = "/api/?mod=effect&action=save-colorto3d"
      let _data = {
        client_id: this.customerValue,
        floorplan_url: referenceImageUrl,
        space_type: areaName,
        style_prompt: this.stylePrompt.trim() || ''
      }

      // 添加到生成列表（pending状态）
      this.generatedImages.push({
        area: areaName,
        effect_id: null,
        url: '',
        status: 'pending',
        isFloorplan: isFloorplan,
        baseStylePrompt: baseStylePrompt // 保存风格提示词
      })

      this.axios.post(_url, _data).then(json => {
        console.log('生成任务提交响应:', json.data)
        if (json.data.errcode === 0) {
          const effectId = json.data.data.effect_id
          // 更新对应任务的effect_id
          const taskIndex = this.generatedImages.findIndex(img => img.area === areaName && !img.effect_id)
          if (taskIndex > -1) {
            this.generatedImages[taskIndex].effect_id = effectId
          }
          // 开始轮询结果
          this.startPollingTask(effectId, areaName, isFloorplan)
        } else {
          // 更新任务状态为失败
          const taskIndex = this.generatedImages.findIndex(img => img.area === areaName && !img.effect_id)
          if (taskIndex > -1) {
            this.generatedImages[taskIndex].status = 'error'
          }
          this.$message.error(`${areaName} 生成任务提交失败`)
          // 如果是3D平面设计图失败，结束生成流程
          if (isFloorplan) {
            this.isGenerating = false
          }
        }
      }).catch(error => {
        console.error('生成任务提交失败:', error)
        // 更新任务状态为失败
        const taskIndex = this.generatedImages.findIndex(img => img.area === areaName && !img.effect_id)
        if (taskIndex > -1) {
          this.generatedImages[taskIndex].status = 'error'
        }
        this.$message.error(`${areaName} 网络错误`)
        // 如果是3D平面设计图失败，结束生成流程
        if (isFloorplan) {
          this.isGenerating = false
        }
      })
    },
    // 3D平面设计图生成完成后，开始生成局部区域图
    generateAreaImages(floorplanImageUrl) {
      if (!this.areasToGenerate || this.areasToGenerate.length === 0) {
        this.isGenerating = false
        this.$message.success('3D平面设计图生成完成！')
        return
      }

      // 获取保存的风格提示词
      const floorplanTask = this.generatedImages.find(img => img.isFloorplan)
      const baseStylePrompt = floorplanTask ? floorplanTask.baseStylePrompt : '现代极简风格，高级感氛围'

      // 为每个区域创建生成任务，使用3D平面设计图作为参考图
      this.areasToGenerate.forEach(area => {
        const prompt = `以第一张3D俯视平面图的${area.name}为精准布局依据，严格保留原始元素，生成1.5-1.6米眼位的写实平视视角渲染图。${baseStylePrompt}。`
        this.submitGenerateTask(prompt, area.name, floorplanImageUrl, false, baseStylePrompt)
      })
    },
    // 开始轮询任务结果
    startPollingTask(effectId, areaName, isFloorplan = false) {
      console.log('开始轮询任务结果，effect_id:', effectId, 'area:', areaName)

      this.pendingTasks++

      const poll = () => {
        let _url = "/api/?mod=effect&action=result"
        let _data = {
          effect_id: effectId
        }

        this.axios.post(_url, _data).then(json => {
          console.log('轮询响应:', json.data)

          if (json.data.errcode === 0) {
            let result = json.data.data
            let resultsLength = result.result ? result.result.length : 0
            console.log('任务状态:', result.status, '结果数量:', resultsLength)

            if (result.status === 1) {
              // 生成成功
              this.pendingTasks--
              console.log(`${areaName} 生成完成，剩余任务: ${this.pendingTasks}`)

              // 更新任务状态和URL
              const taskIndex = this.generatedImages.findIndex(img => img.effect_id === effectId)
              const fileUrl = result.result && result.result.length > 0 ? result.result[0].file_url : ''
              if (taskIndex > -1 && fileUrl) {
                this.generatedImages[taskIndex].url = fileUrl
                this.generatedImages[taskIndex].status = 'completed'
              }

              // 如果是3D平面设计图生成完成，开始生成局部区域图
              if (isFloorplan && fileUrl) {
                this.$message.success('3D平面设计图生成完成，开始生成局部效果图...')
                this.generateAreaImages(fileUrl)
              } else if (this.pendingTasks <= 0) {
                this.isGenerating = false
                this.pendingTasks = 0
                this.$message.success('所有区域生成完成！')
              }
            } else if (result.status === 2) {
              // API返回生成失败
              this.pendingTasks--
              const taskIndex = this.generatedImages.findIndex(img => img.effect_id === effectId)
              if (taskIndex > -1) {
                this.generatedImages[taskIndex].status = 'error'
              }
              this.$message.error(`${areaName} 生成失败`)

              // 如果是3D平面设计图失败，结束整个流程
              if (isFloorplan) {
                this.isGenerating = false
                this.pendingTasks = 0
              } else if (this.pendingTasks <= 0) {
                this.isGenerating = false
                this.pendingTasks = 0
              }
            } else {
              // status === 0，继续轮询（不设置超时，以API返回为准）
              setTimeout(poll, 3000)
            }
          } else {
            // API返回错误，继续轮询（可能是临时错误）
            console.log('API返回错误，继续轮询:', json.data.error)
            setTimeout(poll, 3000)
          }
        }).catch(error => {
          // 网络错误，继续轮询（不因网络问题标记失败）
          console.error('轮询请求失败，继续重试:', error)
          setTimeout(poll, 3000)
        })
      }

      // 立即执行第一次轮询
      poll()
    },
    // 收藏
    handleCollect(img) {
      this.$message.success('收藏成功')
    },
    // 下载
    handleDownload(img) {
      let _href = ''
      let _imgUrl = img.url
      // 处理OSS URL，转换为代理路径
      if (_imgUrl.startsWith('https://oss.ylw.s136.ailo.vip')) {
        _href = _imgUrl.replace('https://oss.ylw.s136.ailo.vip', '/ai_images')
      } else if (_imgUrl.startsWith('https://aigc.oss.ylwai.cn')) {
        _href = _imgUrl.replace('https://aigc.oss.ylwai.cn', '/ai2_images')
      } else {
        _href = _imgUrl
      }
      console.log('下载路径:', _href)
      apiDownload(_href)
    },
    // 预览图片
    previewImage(imageUrl) {
      this.previewImageUrl = imageUrl
      this.previewVisible = true
    },
    // 获取示例列表
    getExampleList() {
      let _url = "/api/?mod=example&action=list"
      let _data = {
        type: 5,  // 5=平面转3D
        pagesize: 10
      }
      this.axios.post(_url, _data).then(json => {
        if (json.data.errcode === 0) {
          this.exampleList = json.data.data.result || []
        }
      }).catch(error => {
        console.error('获取示例列表失败:', error)
      })
    },
    // 预览示例详情
    previewExample(item) {
      this.currentExample = item
      this.exampleDetailVisible = true
    },
    // 使用此提示词
    useThisExample() {
      if (this.currentExample) {
        // 填充风格提示词
        if (this.currentExample.description) {
          this.stylePrompt = this.currentExample.description
        }
        this.exampleDetailVisible = false
        this.$message.success('已应用示例配置')
      }
    }
  }
}
</script>

<style scoped lang="less">
.header {
  z-index: 1001;
}
.main {
  background: #f5f5f5;
  padding: 10px;
  .box {
    padding: 20px;
    background: #fff;
    border-radius: 8px;
    .tool {
      margin-bottom: 20px;
      h4 {
        margin-bottom: 10px;
        font-size: 16px;
        color: #333;
      }
      .search {
        /deep/ .el-select {
          width: 300px;
        }
      }
    }
    .part {
      margin-bottom: 20px;
      h5 {
        margin-bottom: 10px;
        font-size: 14px;
        color: #666;
      }
      .page_header {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 10px;
        .header_icon {
          font-size: 24px;
          color: #50b85c;
        }
        h3 {
          font-size: 18px;
          color: #333;
          margin: 0;
        }
      }
      .upload_header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        h5 {
          margin: 0;
        }
      }
      .selected_plan_info {
        margin-top: 10px;
        padding: 12px 15px;
        background: #f0f9ff;
        border: 1px solid #b3d8ff;
        border-radius: 6px;
        font-size: 14px;
        color: #606266;
        .label {
          font-weight: 500;
        }
      }
      .detected_areas_card {
        padding: 16px;
        background: #f0f9ff;
        border: 1px solid #b3d8ff;
        border-radius: 8px;
        .card_header {
          display: flex;
          align-items: center;
          gap: 8px;
          color: #409eff;
          margin-bottom: 12px;
          i {
            font-size: 16px;
          }
        }
        .area_tags {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }
        .area_loading {
          display: flex;
          align-items: center;
          gap: 8px;
          color: #409eff;
          font-size: 14px;
          i {
            font-size: 16px;
          }
        }
        .area_empty {
          color: #999;
          font-size: 14px;
        }
      }
      .prompt_input_area {
        /deep/ .el-textarea__inner {
          border: 2px solid #e4e7ed;
          border-radius: 8px;
          font-size: 14px;
          line-height: 1.6;
          transition: all 0.3s;
          &:focus {
            border-color: #50b85c;
          }
        }
        .prompt_tips {
          display: flex;
          align-items: center;
          gap: 6px;
          margin-top: 10px;
          padding: 10px 12px;
          background: #fff7e6;
          border: 1px solid #ffd591;
          border-radius: 6px;
          font-size: 13px;
          color: #d48806;
          i {
            font-size: 16px;
            flex-shrink: 0;
          }
          span {
            line-height: 1.5;
          }
        }
      }
      .mode_item {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        padding: 16px;
        border: 2px solid #e4e7ed;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.3s;
        margin-bottom: 12px;
        box-sizing: border-box;
        &:hover {
          border-color: #c0c4cc;
        }
        &.selected {
          border-color: #50b85c;
          background: #f0f9f0;
        }
        .mode_info {
          flex: 1;
          min-width: 0;
          .mode_name {
            font-size: 14px;
            font-weight: 500;
            color: #333;
            word-wrap: break-word;
          }
        }
        .mode_desc {
          margin: 5px 0 0 0;
          font-size: 12px;
          color: #999;
          word-wrap: break-word;
        }
      }
      .mode_radio_group {
        display: flex;
        flex-direction: column;
        width: 100%;
        .mode_item {
          width: 100%;
          box-sizing: border-box;
          /deep/ .el-radio {
            margin-right: 0;
            flex-shrink: 0;
          }
          /deep/ .el-radio__label {
            display: none;
          }
        }
      }
      .area_select_grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 12px;
        .area_item {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 16px;
          border: 2px solid #e4e7ed;
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.3s;
          &:hover {
            border-color: #c0c4cc;
          }
          &.selected {
            border-color: #50b85c;
            background: #f0f9f0;
          }
          .area_name {
            font-size: 14px;
            font-weight: 500;
            color: #333;
          }
        }
      }
    }
    .upload_area {
      .upload_dragger {
        width: 100%;
        /deep/ .el-upload {
          width: 100%;
        }
        /deep/ .el-upload-dragger {
          width: 100%;
          height: 200px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }
      }
      .preview_area {
        position: relative;
        border: 1px solid #e4e7ed;
        border-radius: 8px;
        padding: 10px;
        background: #fafafa;
        text-align: center;
        img {
          max-width: 100%;
          max-height: 200px;
          object-fit: contain;
          border-radius: 4px;
        }
        .clear_btn {
          margin-top: 10px;
        }
      }
    }
    .info_card {
      padding: 16px;
      background: #f5f7fa;
      border-radius: 8px;
      margin-bottom: 20px;
      .info_row {
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        margin-bottom: 8px;
        &:last-child {
          margin-bottom: 0;
        }
        .info_label {
          color: #666;
        }
        .info_value {
          color: #333;
        }
      }
    }
    .btn_save {
      width: 30vw;
      margin-top: 30px;
      .prompt {
        margin-top: 10px;
        width: 100%;
        color: #999;
        text-align: center;
      }
    }
    .result_floorplan {
      margin-bottom: 15px;
      .result_item_3d.floorplan {
        display: grid;
        grid-template-columns: 1fr 1fr;
        background: linear-gradient(135deg, #f5f7fa 0%, #e8f4f8 100%);
        border: 2px solid #409eff;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(64, 158, 255, 0.15);
        overflow: hidden;
        .result_image {
          width: 100%;
          height: 250px;
          object-fit: cover;
          cursor: pointer;
          transition: opacity 0.3s;
          &:hover {
            opacity: 0.8;
          }
        }
        .result_info {
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 15px;
          background: rgba(255, 255, 255, 0.9);
          .result_title {
            color: #409eff;
            font-size: 15px;
            font-weight: 600;
            margin: 0 0 5px 0;
          }
          .result_desc {
            font-size: 12px;
            color: #999;
            margin: 0 0 12px 0;
          }
          .result_actions {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 8px;
          }
        }
        .result_loading, .result_error {
          grid-column: 1 / -1;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 200px;
          font-size: 14px;
          i {
            font-size: 32px;
            margin-bottom: 10px;
          }
        }
        .result_loading {
          color: #409eff;
        }
        .result_error {
          color: #f56c6c;
        }
      }
    }
    .result_list {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 15px;
      .result_item_3d {
        border: 1px solid #e4e7ed;
        border-radius: 8px;
        overflow: hidden;
        .result_loading {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 200px;
          color: #409eff;
          font-size: 14px;
          i {
            font-size: 32px;
            margin-bottom: 10px;
          }
        }
        .result_error {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 200px;
          color: #f56c6c;
          font-size: 14px;
          i {
            font-size: 32px;
            margin-bottom: 10px;
          }
        }
        .result_image {
          width: 100%;
          height: 250px;
          object-fit: cover;
          cursor: pointer;
          transition: opacity 0.3s;
          &:hover {
            opacity: 0.8;
          }
        }
        .result_info {
          padding: 15px;
          .result_title {
            font-size: 14px;
            font-weight: 500;
            color: #333;
            margin: 0 0 5px 0;
          }
          .result_desc {
            font-size: 12px;
            color: #999;
            margin: 0 0 12px 0;
          }
          .result_actions {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 8px;
          }
        }
      }
    }
  }
  .dialog_hint {
    margin: 0 0 20px 0;
    padding: 10px;
    background: #f0f9ff;
    border-radius: 6px;
    font-size: 14px;
    color: #606266;
  }
  .library_loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    color: #409eff;
    font-size: 14px;
    i {
      font-size: 32px;
      margin-bottom: 10px;
    }
  }
  .library_empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    color: #909399;
    i {
      font-size: 48px;
      margin-bottom: 15px;
      color: #dcdfe6;
    }
    p {
      margin: 5px 0;
      font-size: 14px;
      &.hint {
        font-size: 12px;
        color: #c0c4cc;
      }
    }
  }
  .library_grid {
    padding: 0 20px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 15px;
    max-height: 500px;
    overflow-y: auto;
    .library_item {
      border: 1px solid #e4e7ed;
      border-radius: 8px;
      overflow: hidden;
      cursor: pointer;
      transition: all 0.3s;
      &:hover {
        transform: translateY(-4px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      }
      img {
        width: 100%;
        height: 150px;
        object-fit: cover;
      }
      .library_item_info {
        padding: 12px;
        .name {
          font-size: 14px;
          font-weight: 500;
          color: #333;
          margin: 0 0 5px 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .date {
          font-size: 12px;
          color: #999;
          margin: 0;
        }
      }
    }
  }
}
/deep/ .el-dialog__header {
  background: #ffffff;
  padding: 20px !important;
  border-bottom: 1px solid #e4e7ed;
}
/deep/ .el-dialog__body {
  padding: 20px;
  background: #ffffff;
}
// 图片预览弹窗样式
/deep/ .image-preview-dialog {
  background: transparent;
  box-shadow: none;
  margin: 0 !important;
  position: fixed !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
    background: transparent;
  }
  .preview-dialog-image {
    max-width: 90vw;
    max-height: 90vh;
    object-fit: contain;
    display: block;
    border-radius: 8px;
  }
}
// 示例展示样式
.example_section {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #e4e7ed;
  .example_header {
    margin-bottom: 15px;
    h5 {
      font-size: 16px;
      color: #333;
      font-weight: 500;
    }
  }
  .example_grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 15px;
    .example_item {
      border: 1px solid #e4e7ed;
      border-radius: 8px;
      overflow: hidden;
      cursor: pointer;
      transition: all 0.3s;
      &:hover {
        transform: translateY(-4px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      }
      img {
        width: 100%;
        height: 150px;
        object-fit: cover;
      }
      .example_info {
        padding: 10px;
        .example_title {
          font-size: 14px;
          font-weight: 500;
          color: #333;
          margin-bottom: 5px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .example_desc {
          font-size: 12px;
          color: #666;
          margin-bottom: 8px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          line-height: 1.4;
          height: 33.6px;
        }
        .example_model {
          font-size: 12px;
          color: #50b85c;
          margin-bottom: 8px;
        }
        .example_tags {
          .el-tag {
            margin-right: 5px;
            margin-bottom: 5px;
          }
        }
      }
    }
  }
}
// 示例详情弹窗样式 - 使用深度选择器
::v-deep .example-detail-dialog {
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  background: #fff !important;

  .el-dialog__header {
    background: linear-gradient(135deg, #ccc 0%, #ddd 100%) !important;
    padding: 20px !important;
    margin: 0 !important;
    border-bottom: none !important;

    .el-dialog__title {
      color: #fff !important;
      font-size: 18px !important;
      font-weight: 600 !important;
    }

    .el-dialog__headerbtn {
      top: 20px !important;
      right: 20px !important;

      .el-dialog__close {
        color: #fff !important;
        font-size: 20px !important;

        &:hover {
          color: rgba(255, 255, 255, 0.8) !important;
        }
      }
    }
  }

  .el-dialog__body {
    max-height: calc(90vh - 120px);
    overflow-y: auto;
    background: #fff !important;
    padding: 0 !important;
  }
}
.example_detail {
  padding: 20px;

  // 横排显示两张图片
  .detail_images_row {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
    .image_item {
      flex: 1;
      .image_label {
        font-size: 14px;
        color: #666;
        margin-bottom: 10px;
        font-weight: 500;
      }
      img {
        width: 100%;
        max-height: 60vh;
        object-fit: contain;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0,0,0,0.1);
      }
    }
  }

  // 单图布局（左右结构）
  .detail_single_layout {
    display: flex;
    gap: 30px;
    .detail_left {
      flex: 1;
      img {
        width: 100%;
        max-height: 60vh;
        object-fit: contain;
        border-radius: 8px;
      }
    }
    .detail_right {
      flex: 1;
    }
  }

  // 信息显示在底部
  .detail_info_bottom {
    padding-top: 20px;
    border-top: 1px solid #eee;
  }

  // 详情项样式
  .detail_item {
    margin-bottom: 15px;
    label {
      display: block;
      font-size: 14px;
      color: #999;
      margin-bottom: 5px;
    }
    p {
      font-size: 14px;
      color: #333;
      line-height: 1.6;
    }
  }

  .detail_actions {
    margin-top: 30px;
  }
}
</style>

<style lang="less">
// 示例详情弹窗标题栏样式 - 非 scoped，确保能覆盖 Element UI 样式
.example-detail-dialog {
  .el-dialog__header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    padding: 20px !important;
    margin: 0 !important;
    border-bottom: none !important;
  }

  .el-dialog__title {
    color: #fff !important;
    font-size: 18px !important;
    font-weight: 600 !important;
  }

  .el-dialog__headerbtn {
    top: 20px !important;
    right: 20px !important;
  }

  .el-dialog__close {
    color: #fff !important;
    font-size: 20px !important;

    &:hover {
      color: rgba(255, 255, 255, 0.8) !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ColorTo3D/Index.vue